import { Tooltip } from 'shared/mui/Tooltip';
import { Typography } from 'shared/mui/Typography';
import { FunctionField, FunctionFieldProps } from 'shared/react-admin/Fields';
import { MerchantAccount } from 'types/embedded/merchantAccount';

import { TypographyStyled } from './MerchantShowAccountsNameField.styled';

type Props = {
  label: string;
  onClick: (record: MerchantAccount) => void;
} & Omit<FunctionFieldProps, 'render' | 'onClick'>;

export const MerchantShowAccountsNameField: React.FC<Props> = ({ label, onClick, ...rest }) => {
  return (
    <FunctionField
      label={label}
      render={(record: MerchantAccount) => {
        return (
          <Tooltip
            placement="bottom-start"
            title={<Typography fontSize={12}>{record?.name}</Typography>}
          >
            <TypographyStyled onClick={() => onClick(record)} variant="body2">
              {record?.name}
            </TypographyStyled>
          </Tooltip>
        );
      }}
      {...rest}
    />
  );
};
